import React, { useState } from "react";
import "./sub1.css";
import { Helmet } from "react-helmet";
import contactConfig from "../../confi";
export default function OfficeBoyServices() {
  const [formData, setFormData] = useState({
    companyName: "",
    contactPerson: "",
    email: "",
    phone: "",
    officeType: "",
    staffCount: "",
    serviceType: "",
    startDate: "",
    address: "",
    specialRequirements: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert(
      "Office Boy service request submitted successfully! We will contact you soon.",
    );
    // Reset form
    setFormData({
      companyName: "",
      contactPerson: "",
      email: "",
      phone: "",
      officeType: "",
      staffCount: "",
      serviceType: "",
      startDate: "",
      address: "",
      specialRequirements: "",
    });
  };

  const servicesOffered = [
    {
      icon: "🧹",
      title: "Office Maintenance & Cleaning",
      description: "Keeping desks, cabins, and pantry areas neat and tidy",
    },
    {
      icon: "☕",
      title: "Serving Beverages & Snacks",
      description: "To staff, clients, and visitors",
    },
    {
      icon: "📦",
      title: "Document Handling & Delivery",
      description: "Assisting with courier, files, and paperwork movement",
    },
    {
      icon: "🧾",
      title: "Pantry Management",
      description: "Maintaining tea/coffee machines and pantry supplies",
    },
    {
      icon: "🚪",
      title: "Front Office Assistance",
      description: "Welcoming guests, attending calls, and basic admin tasks",
    },
    {
      icon: "🧰",
      title: "General Office Support",
      description:
        "Helping with day-to-day requirements of staff and management",
    },
  ];

  const serviceFeatures = [
    "Background verified and identity-checked",
    "Trained in office etiquette and professional behavior",
    "Reliable, punctual, and well-groomed",
    "Flexible working hours (full-time or part-time)",
    "Multilingual support – Hindi, Gujarati, English",
    "Uniformed staff available on request",
    "Replacement guarantee in case of absence",
  ];

  const whyChooseUs = [
    {
      title: "Professional Selection Process",
      description:
        "Every staff member is screened, interviewed, and trained before joining your office.",
      icon: "✅",
    },
    {
      title: "Corporate Reliability",
      description:
        "Trusted by small businesses, hospitals, and MNCs across Gujarat.",
      icon: "🏢",
    },
    {
      title: "Flexible Contracts",
      description: "Hire on monthly, part-time, or full-time basis.",
      icon: "⏰",
    },
    {
      title: "Continuous Support",
      description:
        "Dedicated client service team for quick replacements or queries.",
      icon: "📞",
    },
  ];

  const processSteps = [
    {
      step: "1",
      title: "Share Your Requirement",
      description: "Number of office boys, working hours, and job type",
    },
    {
      step: "2",
      title: "Get Profiles",
      description:
        "We send shortlisted, verified candidates based on your needs",
    },
    {
      step: "3",
      title: "Interview & Selection",
      description: "You select the best-fit staff for your organization",
    },
    {
      step: "4",
      title: "Placement & Follow-up",
      description:
        "The selected candidate joins; we monitor satisfaction and performance",
    },
  ];

  const testimonials = [
    {
      name: "Mr. Rajesh Mehta",
      position: "HR Manager, Ahmedabad",
      rating: "⭐⭐⭐⭐⭐",
      text: "Our company has been using JP Home Services for 2 years. Their office boys are punctual, disciplined, and understand corporate work culture.",
    },
    {
      name: "Ms. Sneha Patel",
      position: "Owner, Fashion House, Surat",
      rating: "⭐⭐⭐⭐⭐",
      text: "We hired 2 office boys for our showroom in Surat — extremely professional and well-trained. Highly recommend their service!",
    },
  ];

  const benefits = [
    "Professional and verified office support staff",
    "Trained in corporate etiquette and behavior",
    "Flexible full-time or part-time options",
    "Multilingual communication skills",
    "Quick replacement guarantee",
    "Trusted by businesses across Gujarat",
    "Available in all major cities of Gujarat",
  ];

  const cities = [
    "Ahmedabad",
    "Surat",
    "Vadodara",
    "Gandhinagar",
    "Rajkot",
    "Bharuch",
    "Anand",
    "Mehsana",
    "Vapi",
  ];

  const officeBoyPackages = [
    {
      name: "Part-Time Office Boy",
      price: "₹7,999",
      period: "/month",
      features: [
        "✓ 4 hours daily service",
        "✓ Basic office maintenance",
        "✓ Beverage service",
        "✓ Document handling",
        "✓ Professional behavior",
        "✗ Full pantry management",
        "✗ Front office duties",
      ],
      popular: false,
    },
    {
      name: "Full-Time Office Assistant",
      price: "₹12,999",
      period: "/month",
      features: [
        "✓ 8 hours daily service",
        "✓ Complete office support",
        "✓ Pantry management",
        "✓ Guest handling",
        "✓ Courier assistance",
        "✓ Professional uniform",
        "✗ Multiple staff",
      ],
      popular: true,
    },
    {
      name: "Premium Office Support",
      price: "₹18,999",
      period: "/month",
      features: [
        "✓ 9 hours daily service",
        "✓ Multi-skilled assistant",
        "✓ Front office support",
        "✓ Basic admin tasks",
        "✓ Emergency coverage",
        "✓ Priority replacement",
        "✓ Dedicated training",
      ],
      popular: false,
    },
    {
      name: "Multiple Staff Package",
      price: "Custom",
      period: "Quote",
      features: [
        "✓ Multiple office boys",
        "✓ Custom working hours",
        "✓ Specialized training",
        "✓ Shift management",
        "✓ Dedicated supervisor",
        "✓ Premium support",
        "✓ Flexible contracts",
      ],
      popular: false,
    },
  ];
  const handleCall = () => {
    window.open(`tel:${contactConfig.phone}`);
  };

  const handleWhatsApp = () => {
    const phoneNumber = `${contactConfig.phone}`;
    const message = "Hello, I would like to know more about your services.";
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, "_blank");
  };
  return (
    <div className="main-content-wrapper">
      <Helmet>
        <title>
          Verified Office Boy Services in Ahmedabad - JP Home Services
        </title>
        <meta
          name="description"
          content="JP Home Services provides trained and background-verified office boy services in Ahmedabad for offices, showrooms & businesses. Hire trusted staff now!"
        />
        <meta
          name="keywords"
          content="Office Boy Services Ahmedabad, Office Staff Provider, Corporate Helper Services Ahmedabad, Office Assistant Gujarat, Cleaning & Maintenance Staff Ahmedabad, JP Home Services"
        />
        <meta
          name="robots"
          content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1"
        />
        <link
          rel="canonical"
          href="https://jphomeservice.in/office-boy-services-in-ahmedabad"
        />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Verified Office Boy Services in Ahmedabad - JP Home Services"
        />
        <meta
          property="og:description"
          content="JP Home Services provides trained and background-verified office boy services in Ahmedabad for offices, showrooms & businesses. Hire trusted staff now!"
        />
        <meta
          property="og:image"
          content="https://jphomeservice.in/static/media/TRANSPARNT%20LOGO.1a150556bfeacec71cee.png"
        />
        <meta
          property="og:url"
          content="https://jphomeservice.in/office-boy-services-in-ahmedabad"
        />
        <meta property="og:site_name" content="JP Home Services" />
        <meta property="og:type" content="website" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@" />
        <meta
          name="twitter:title"
          content="Verified Office Boy Services in Ahmedabad - JP Home Services"
        />
        <meta
          name="twitter:description"
          content="JP Home Services provides trained and background-verified office boy services in Ahmedabad for offices, showrooms & businesses. Hire trusted staff now!"
        />
        <meta
          name="twitter:image"
          content="https://jphomeservice.in/static/media/TRANSPARNT%20LOGO.1a150556bfeacec71cee.png"
        />

        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">
          {`
        {
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          "name": "Office Boy Services in Ahmedabad",
          "image": "https://jphomeservice.in/static/media/TRANSPARNT%20LOGO.1a150556bfeacec71cee.png",
          "@id": "",
          "url": "https://jphomeservice.in/office-boy-services-in-ahmedabad",
          "telephone": "+919327365056",
          "priceRange": "₹₹",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "A-316-317, Swaminarayan Avenue,  Nr. AEC Cross Road, Naranpura",
            "addressLocality": "Ahmedabad, Gujarat",
            "postalCode": "380013",
            "addressCountry": "IN"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 23.0542109,
            "longitude": 72.5482134
          },
          "openingHoursSpecification": {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": [
              "Monday",
              "Tuesday",
              "Wednesday",
              "Thursday",
              "Friday",
              "Saturday",
              "Sunday"
            ],
            "opens": "00:00",
            "closes": "23:59"
          },
          "sameAs": [
            "https://www.facebook.com/jphomeservice.in/",
            "https://www.instagram.com/jp_home_service/"
          ] 
        }
    `}
        </script>
        <script type="application/ld+json">
          {`
      {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "@id": "https://jphomeservice.in/office-boy-services-in-ahmedabad#webpage",
        "url": "https://jphomeservice.in/office-boy-services-in-ahmedabad",
        "name": "Verified Office Boy Services in Ahmedabad - JP Home Services",
        "description": "JP Home Services provides trained and background-verified office boy services in Ahmedabad for offices, showrooms & businesses. Hire trusted staff now!",
        "inLanguage": "en-IN",
        "isPartOf": {
          "@type": "WebSite",
          "@id": "https://jphomeservice.in/#website",
          "name": "JP Home Services",
          "url": "https://jphomeservice.in/"
        },
        "publisher": {
          "@type": "Organization",
          "@id": "https://jphomeservice.in/#organization",
          "name": "JP Home Services",
          "url": "https://jphomeservice.in/"
        }
      }
    `}
        </script>
      </Helmet>

      <div className="office-boy-container">
        {/* Hero Section */}
        <section className="office-hero-section">
          <div className="container">
            <div className="office-hero-content">
              <h1>Office Boy Services in Ahmedabad, Surat & Across Gujarat</h1>
              <p className="hero-subtitle">
                <strong>
                  Reliable, Trained & Professional Office Support Staff
                </strong>
              </p>
              <p className="hero-description">
                A well-managed office needs more than systems — it needs
                dependable people who ensure everything runs smoothly behind the
                scenes. At JP Home Services, we provide trained, trustworthy,
                and efficient office boys and office assistants who make your
                workplace operations seamless and professional.
              </p>
              <p className="hero-description">
                Whether you run a startup, corporate office, clinic, or
                showroom, our Office Boy Services in Ahmedabad, Surat, and
                across Gujarat are designed to help you focus on your core
                business while we take care of the daily tasks.
              </p>
              <div className="hero-stats">
                <div className="stat-item">
                  <span className="stat-number">500+</span>
                  <p className="stat-label">Businesses Served</p>
                </div>
                <div className="stat-item">
                  <span className="stat-number">100%</span>
                  <p className="stat-label">Verified Staff</p>
                </div>
                <div className="stat-item">
                  <span className="stat-number">24/7</span>
                  <p>Support</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="floating-contact-icons">
          <div className="contact-icon whatsapp-icon" onClick={handleWhatsApp}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893c0-3.18-1.24-6.169-3.495-8.424" />
            </svg>
          </div>
          <div className="contact-icon call-icon" onClick={handleCall}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path d="M20 10.999h2C22 5.869 18.127 2 12.99 2v2C17.052 4 20 6.943 20 10.999z" />
              <path d="M13 8c2.103 0 3 .897 3 3h2c0-3.225-1.775-5-5-5v2zm3.422 5.443a1.001 1.001 0 00-1.391.043l-2.393 2.461c-.576-.11-1.734-.471-2.926-1.66-1.192-1.193-1.553-2.354-1.66-2.926l2.459-2.394a1 1 0 00.043-1.391L6.859 3.513a1 1 0 00-1.391-.087l-2.17 1.861a1 1 0 00-.29.649c-.015.25-.301 6.172 4.291 10.766C11.305 20.707 16.323 21 17.705 21c.202 0 .326-.006.359-.008a.992.992 0 00.648-.291l1.86-2.171a1 1 0 00-.086-1.391l-4.064-3.696z" />
            </svg>
          </div>
        </div>

        {/* Services Offered Section */}
        <section className="services-offered-section">
          <div className="container">
            <div className="section-header1">
              <h2>Our Office Boy Services Include</h2>
              <p>
                We provide qualified and verified office support staff for
                various professional environments
              </p>
            </div>

            <div className="services-grid">
              {servicesOffered.map((service, index) => (
                <div key={index} className="service-card">
                  <div className="service-icon">{service.icon}</div>
                  <h3>{service.title}</h3>
                  <p>{service.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Features Section */}
        <section className="features-section">
          <div className="container">
            <div className="section-header">
              <h2>Features of JP Home Services Office Boys</h2>
            </div>
            <div className="features-list">
              {serviceFeatures.map((feature, index) => (
                <div key={index} className="feature-item">
                  <span className="check-icon">✓</span>
                  <span>{feature}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Pricing Packages Section */}
        {/* <section className="pricing-packages-section">
          <div className="container">
            <div className="section-header1">
              <h2>Office Boy Service Packages</h2>
              <p>Professional office support packages designed for different business needs</p>
            </div>

            <div className="packages-grid">
              {officeBoyPackages.map((pkg, index) => (
                <div key={index} className={`package-card ${pkg.popular ? 'popular' : ''}`}>
                  {pkg.popular && <div className="popular-badge">Most Popular</div>}
                  <h3>{pkg.name}</h3>
                  <div className="package-price">
                    {pkg.price}<span>{pkg.period}</span>
                  </div>
                  <ul className="package-features">
                    {pkg.features.map((feature, idx) => (
                      <li key={idx} className={feature.startsWith('✗') ? 'not-included' : ''}>
                        {feature}
                      </li>
                    ))}
                  </ul>
                  <button className="package-btn">
                    {pkg.price === 'Custom' ? 'Get Quote' : 'Select Package'}
                  </button>
                </div>
              ))}
            </div>
          </div>
        </section> */}

        {/* Why Choose Us Section */}
        <section className="why-choose-section">
          <div className="container">
            <div className="section-header">
              <h2>Why Choose Office Boys from JP Home Services?</h2>
            </div>

            <div className="features-grid">
              {whyChooseUs.map((feature, index) => (
                <div key={index} className="feature-card">
                  <div className="feature-icon1">{feature.icon}</div>
                  <h3>{feature.title}</h3>
                  <p>{feature.description}</p>
                </div>
              ))}
            </div>

            <div className="additional-benefits">
              <div className="benefit-item">
                <span className="check-icon">✓</span>
                <span>
                  Local Presence – Our network covers Ahmedabad, Surat,
                  Vadodara, and all major Gujarat cities.
                </span>
              </div>
            </div>

            <div className="trust-note">
              <p>
                <strong>
                  We don't just supply manpower — we deliver professionalism,
                  discipline, and trust to your workplace.
                </strong>
              </p>
            </div>
          </div>
        </section>

        {/* How It Works Section */}
        <section className="process-section">
          <div className="container">
            <div className="section-header1">
              <h2>How Our Office Boy Service Works</h2>
            </div>

            <div className="process-steps">
              {processSteps.map((step, index) => (
                <div key={index} className="process-step">
                  <div className="step-number">{step.step}</div>
                  <div className="step-content">
                    <h3>{step.title}</h3>
                    <p>{step.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* <section className="booking-section">
          <div className="container">
            <div className="booking-content">
              <div className="booking-info">
                <h2>Request Office Boy Service</h2>
                <p>Fill out the form and we'll help you find the perfect office support staff for your business.</p>
                
                <div className="service-highlights">
                  <div className="highlight-item">
                    <span className="highlight-icon">✅</span>
                    <span>Background verified and professional staff</span>
                  </div>
                  <div className="highlight-item">
                    <span className="highlight-icon">✅</span>
                    <span>Trained in corporate etiquette</span>
                  </div>
                  <div className="highlight-item">
                    <span className="highlight-icon">✅</span>
                    <span>Flexible timing options</span>
                  </div>
                  <div className="highlight-item">
                    <span className="highlight-icon">✅</span>
                    <span>Quick replacement guarantee</span>
                  </div>
                </div>

                <div className="contact-info">
                  <h3>Need Immediate Staff?</h3>
                  <p>Call us: <strong>+91 XXXXX XXXXX</strong></p>
                  <p>Email: <strong>office@jphomeservices.com</strong></p>
                </div>
              </div>

              <div className="booking-form-container">
                <form className="booking-form" onSubmit={handleSubmit}>
                  <h3>Get Office Support Staff</h3>
                  
                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="companyName">Company Name *</label>
                      <input
                        type="text"
                        id="companyName"
                        name="companyName"
                        value={formData.companyName}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="contactPerson">Contact Person *</label>
                      <input
                        type="text"
                        id="contactPerson"
                        name="contactPerson"
                        value={formData.contactPerson}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="email">Email *</label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="phone">Phone Number *</label>
                      <input
                        type="tel"
                        id="phone"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="officeType">Office Type *</label>
                      <select
                        id="officeType"
                        name="officeType"
                        value={formData.officeType}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Select Office Type</option>
                        <option value="corporate">Corporate Office</option>
                        <option value="startup">Startup</option>
                        <option value="clinic">Clinic/Hospital</option>
                        <option value="showroom">Showroom/Retail</option>
                        <option value="school">School/College</option>
                        <option value="other">Other</option>
                      </select>
                    </div>
                    <div className="form-group">
                      <label htmlFor="staffCount">Number of Staff Required *</label>
                      <select
                        id="staffCount"
                        name="staffCount"
                        value={formData.staffCount}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Select Count</option>
                        <option value="1">1 Office Boy</option>
                        <option value="2">2 Office Boys</option>
                        <option value="3">3 Office Boys</option>
                        <option value="4+">4+ Office Boys</option>
                      </select>
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="serviceType">Service Type *</label>
                      <select
                        id="serviceType"
                        name="serviceType"
                        value={formData.serviceType}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Select Service Type</option>
                        <option value="part-time">Part-Time (4 hours)</option>
                        <option value="full-time">Full-Time (8 hours)</option>
                        <option value="premium">Premium (9 hours)</option>
                        <option value="multiple">Multiple Staff</option>
                        <option value="custom">Custom Requirement</option>
                      </select>
                    </div>
                    <div className="form-group">
                      <label htmlFor="startDate">Preferred Start Date *</label>
                      <input
                        type="date"
                        id="startDate"
                        name="startDate"
                        value={formData.startDate}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label htmlFor="address">Office Address *</label>
                    <textarea
                      id="address"
                      name="address"
                      value={formData.address}
                      onChange={handleChange}
                      placeholder="Enter your complete office address with area and city"
                      rows="3"
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="specialRequirements">Special Requirements</label>
                    <textarea
                      id="specialRequirements"
                      name="specialRequirements"
                      value={formData.specialRequirements}
                      onChange={handleChange}
                      placeholder="Any specific skills required, uniform preferences, language requirements, or special office duties..."
                      rows="3"
                    />
                  </div>

                  <button type="submit" className="submit-btn">
                    Request Office Staff
                  </button>
                </form>
              </div>
            </div>
          </div>
        </section> */}

        {/* Testimonials Section */}
        <section className="testimonials-section">
          <div className="container2">
            <h2>Client Testimonials</h2>
            <div className="testimonials-grid">
              {testimonials.map((testimonial, index) => (
                <div key={index} className="testimonial-card">
                  <div className="testimonial-rating">{testimonial.rating}</div>
                  <p className="testimonial-text">"{testimonial.text}"</p>
                  <div className="testimonial-author">
                    <strong>{testimonial.name}</strong>
                    <span>{testimonial.position}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Benefits Section */}
        <section className="benefits-section">
          <div className="container">
            <div className="section-header1">
              <h2>Key Benefits</h2>
              <p>
                Professional office support that enhances your workplace
                efficiency
              </p>
            </div>

            <div className="benefits-grid">
              {benefits.map((benefit, index) => (
                <div key={index} className="benefit-item-large">
                  <span className="check-icon">✓</span>
                  <span>{benefit}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Service Coverage Section */}
        <section className="coverage-section">
          <div className="container">
            <div className="section-header1">
              <h2>Service Coverage</h2>
              <p>
                Our Office Boy Services are available across Gujarat, including:
              </p>
            </div>

            <div className="cities-grid">
              {cities.map((city, index) => (
                <div key={index} className="city-item">
                  {city}
                </div>
              ))}
            </div>

            <div className="coverage-note">
              <p>
                <strong>
                  Wherever your office is located, JP Home Services provides
                  reliable office staff to support your business operations.
                </strong>
              </p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
